// extracted by mini-css-extract-plugin
export default {"sobre":"Sobre_sobre__j4kPe","caixa1":"Sobre_caixa1__y+Pnb","botaoSaibaMais":"Sobre_botaoSaibaMais__+rEMl","caixa2":"Sobre_caixa2__1AwLL"};